import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getStorage, ref } from "@libs/storage/firebase";

const fbc = JSON.parse(process.env.EXPO_PUBLIC_FIREBASE_CONFIG || "{}");

const app = initializeApp(fbc);

const _auth = getAuth(app);
_auth.tenantId = process.env.EXPO_PUBLIC_FIREBASE_AUTH_TENANT_ID || null;
export const auth = _auth;

const storage = getStorage(app);
export const storageRef = (path: string) => ref(storage, path);
